<template>
    <div>
        <header>
            <div class="top">
                <div class="banner">
                    <van-row>
                        <van-col span="6" @click="back"><img class="back-icon" src="@/assets/share/home/back.png">
                        </van-col>
                        <van-col span="12">
                            <div class="banner-title">切换城市</div>
                        </van-col>
                        <van-col span="6" @click="switchSelct()">
                            <van-icon class="search" name="search"/>
                        </van-col>
                    </van-row>
                </div>
                <div class="apply-box" v-show="showSelect">
                    <div class="apply-value">
                        <van-field v-model="selectCity" @input="selectCityFun()" placeholder="请输入搜索城市名称"/>
                    </div>
                </div>
                <div class="current-city" @click="setCurrentCity(city)">当前城市：{{city}}</div>
            </div>

        </header>
        <div class="select-city-box1">
            <div class="city-box" v-if="!showResult">
                <div v-for="(item, i) in cityList">
                    <div class="city-init" :id="'cap' + i">{{item.key}}</div>
                    <div class="city-item" v-for="c in item.list" @click="setCurrentCity(c)">{{c}}</div>
                </div>
            </div>
            <div class="city-box" v-if="showResult">
                <div v-for="(item, i) in resultList">
                    <div class="city-init" :id="'cap' + i">{{item.key}}</div>
                    <div class="city-item" v-for="c in item.list" @click="setCurrentCity(c)">{{c}}</div>
                </div>
            </div>
            <div class="right-box" v-if="!showResult">
                <div class="right-item" @click="selectCap(item.key, i)" v-for="(item, i) in cityList"
                     :style="{'height': capHeight + 'px'}">{{item.key}}
                </div>
            </div>

            <div class="right-box" v-if="showResult" :style="{'height': rightTop + 'px'}">
                <div class="right-item" @click="selectCap(item.key, i)" v-for="(item, i) in resultList"
                     :style="{'height': capHeight + 'px'}">{{item.key}}
                </div>
            </div>

            <div class="none-box" v-if="resultList.length == 0 && showResult">
                <van-icon class="none-icon" name="info-o"/>
                <div class="none-text">没有找到，换个词试试~</div>
            </div>
        </div>
    </div>
</template>

<script>
    import Pinyin from 'js-pinyin';
    import {Toast} from 'vant'

    export default {
        name: 'selectCity',
        data() {
            return {
                city: '成都',
                showSelect: 0,
                selectCity: '',
                showResult: 0,
                orgList: [],
                cityList: [],
                resultList: [],
                capHeight: 20,
                rightTop: 161,
            }
        },
        mounted() {
            let orgList = JSON.parse(localStorage.getItem("orgList"));
            if (orgList) {
                this.orgList = orgList;
            }
            let cityList = JSON.parse(localStorage.getItem("cityList"));
            if (cityList) {
                this.cityList = cityList;
            } else {
                this.getCity();
            }
            this.getCapHeight();
        },
        methods: {
            getCapHeight() {
                this.capHeight = (document.documentElement.clientHeight - 181) / 23;
            },
            back() {
                this.$router.back();
            },
            getCity() {
                this.$api.share.getCity().then(res => {
                    this.cityList = this.sortByFirstLetter(res.info);
                    this.orgList = res.info;
                    localStorage.setItem("cityList", JSON.stringify(this.cityList));
                    localStorage.setItem("orgList", JSON.stringify(this.orgList));
                })
            },
            sortByFirstLetter(origin) {
                // 将目标数据进行排序
                origin = origin.sort((pre, next) => Pinyin.getFullChars(pre).localeCompare(Pinyin.getFullChars(next)))
                const newArr = []
                origin.map(item => {
                    // 取首字母
                    const key = Pinyin.getFullChars(item).charAt(0)
                    const index = newArr.findIndex(subItem => subItem.key === key)
                    if (index < 0) {
                        newArr.push({
                            key: key,
                            list: [item]
                        })
                    } else {
                        newArr[index].list.push(item)
                    }
                })
                return newArr
            },
            selectCityFun() {
                let e = this.selectCity;
                if (e) {
                    this.showResult = 1;
                    let result = []
                    for (let i = 0; i < this.orgList.length; i++) {
                        if (this.orgList[i].indexOf(e) != -1) {
                            result.push(this.orgList[i]);
                        }
                    }
                    this.resultList = this.sortByFirstLetter(result);
                } else {
                    this.showResult = 0
                }

            },
            selectCap(key, i) {
                key = '\n \n' + key + '\n \n \n'
                Toast({
                    getContainer: '#app',
                    message: key,
                });
                // offsetTop距离上方或上层控件的位置
                let clientWidth = document.documentElement.clientWidth;
                let ratio = clientWidth / 375;
                let top = 155 * ratio;
                let h = document.getElementById('cap' + i).offsetTop - top;
                // scrollTop滚动到指定位置
                document.body.scrollTop = h;
                document.documentElement.scrollTop = h;
                // 解决ios兼容问题
                // let u = navigator.userAgent;
                // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
                // if (!isAndroid) {
                //     window.scrollBy(0, h);
                // }
            },
            switchSelct() {
                this.showSelect = !this.showSelect;
                // let clientWidth = document.documentElement.clientWidth;
                // let ratio = clientWidth / 375;
                // if (this.showSelect) {
                //     this.rightTop = 201 * ratio;
                //     // document.body.scrollTop -= 59 * ratio;
                //     // document.documentElement.scrollTop -= 59 * ratio;
                // } else {
                //     this.rightTop = 161 * ratio;
                //     // document.body.scrollTop += 59 * ratio;
                //     // document.documentElement.scrollTop += 59 * ratio;
                // }
            },
            setCurrentCity(c) {
                localStorage.setItem('selectCity', c);
                this.back();
            }
        }
    }
</script>

<style scoped>
    .apply-box {
        margin-top: 15px;
    }

    .apply-value {
        width: 345px;
        height: 44px;
        margin: 0 auto;
        background: #202020;
        opacity: 1;
        border-radius: 6px;
        position: relative;
    }

    /deep/ input {
        background-color: transparent;
        color: #E9E9E9;
        font-size: 15px;
        caret-color: #20D38F;
    }

    /deep/ input::-webkit-input-placeholder {
        color: #FFFFFF;
        opacity: 0.6;
    }

    /deep/ input::-moz-placeholder {
        color: #FFFFFF;
        opacity: 0.6;
    }

    /deep/ input:-moz-placeholder {
        color: #FFFFFF;
        opacity: 0.6;
    }

    /deep/ input::-ms-input-placeholder {
        color: #FFFFFF;
        opacity: 0.6;
    }

    /deep/ .van-cell {
        background-color: #404040 !important;
        border-radius: 6px;
    }

    .select-city-box1 {
        margin-top: 154px;
        height: 667px;
    }

    .select-city-box2 {
        margin-top: 165px;
    }

    .city-box {
        width: 100%;
        height: calc(100% - 155px);
    }

    .search {
        float: right;
        margin-top: 10px;
        margin-right: 16px;
        font-size: 24px;
    }

    .current-city {
        width: 347px;
        height: 41px;
        background: #202020;
        text-align: left;
        font-size: 17px;
        padding-left: 28px;
        line-height: 41px;
        margin: 12px auto;
    }

    .city-init {
        color: #A3A3A3;
        font-size: 17px;
        margin-left: 31px;
        height: 30px;
        line-height: 30px;
    }

    .city-item {
        width: 347px;
        height: 41px;
        background: #202020;
        text-align: left;
        font-size: 17px;
        padding-left: 28px;
        line-height: 41px;
        border-bottom: 1px solid #707070;
    }

    .top {
        background: #000000;
        padding-bottom: 1px;
    }

    .right-box {
        position: fixed;
        height: calc(100% - 181px);
        right: 0px;
        color: #A3A3A3;
        font-size: 15px;
        top: 161px;
        z-index: 1111;
        -webkit-transform: translateZ(0);
    }

    .right-item {
        padding-left: 40px;
        width: 20px;
        text-align: center;
        padding-right: 10px;
    }

    .result-right {
        top: 170px
    }

    .none-box {
        text-align: center;
        margin-top: 30px;
    }

    .none-icon {
        font-size: 40px;
        color: #707070;
    }

    .none-text {
        font-size: 15px;
        margin-top: 10px;
        opacity: 0.9;
    }
</style>



// WEBPACK FOOTER //
// src/views/share/selectCity.vue